import React from "react";

import * as S from "./GroupShellTitleDescriptionContainer.style";

interface Props {
  mainGroupShellTitle: string | null;
  titleFontSize?: string;
  description?: string;
  onClickHandler?: () => void;
}

const GroupShellTitleDescriptionContainer = ({
  mainGroupShellTitle,
  description,
  titleFontSize = "1.2rem",
  onClickHandler,
}: Props) => {
  if (!mainGroupShellTitle) return null;

  return (
    <S.TitleDescriptionWrapper>
      <S.MainGroupShellTitle
        titleFontSize={titleFontSize}
        onClick={onClickHandler}
      >
        {mainGroupShellTitle}
      </S.MainGroupShellTitle>
      {description && <S.Description>{description}</S.Description>}
    </S.TitleDescriptionWrapper>
  );
};

export default GroupShellTitleDescriptionContainer;
